import { render, staticRenderFns } from "./AddMenu.vue?vue&type=template&id=7357e5ee"
import script from "./AddMenu.vue?vue&type=script&lang=tsx"
export * from "./AddMenu.vue?vue&type=script&lang=tsx"
import style0 from "./AddMenu.vue?vue&type=style&index=0&id=7357e5ee&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports